import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'

import ArrowDownIcon from '../../../../../../../packages/ui/icons/arrow-down'
import useTranslate from '../../../../lib/hooks/use-translate'
import ArrowPoints from './arrow-points'

type Props = {
  position: string
}

const PayScaleInformation = ({ position }: Props) => {
  const { t } = useTranslate()

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="caption" color={tailwindColors.secondary.DEFAULT}>
        {t('staff.personal.space.pay.scale.Box.title')}
      </Typography>
      <ArrowPoints
        title={t('staff.personal.space.pay.scale.Box.first.info.title')}
        titleExplanation={t('staff.personal.space.pay.scale.Box.first.info.title.explanation')}
        points={[
          <Typography
            key={'point-1.1'}
            variant="secondary-body"
            color={tailwindColors.grey.DEFAULT}
          >
            {t('staff.personal.space.pay.scale.Box.first.info.one')}&nbsp;
            <span className="font-bold">50€ </span>
          </Typography>,
          <Typography
            key={'point-1.2'}
            variant="secondary-body"
            color={tailwindColors.grey.DEFAULT}
          >
            {t('staff.personal.space.pay.scale.Box.first.info.two')}&nbsp;
            <span className="font-bold">80€ </span>
          </Typography>
        ]}
        note={
          <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
            {t('staff.personal.space.pay.scale.Box.first.general')}
          </Typography>
        }
      />
      <ArrowPoints
        title={t('staff.personal.space.pay.scale.Box.second.info.title')}
        points={[
          <Typography
            key={'point-2.1'}
            variant="secondary-body"
            color={tailwindColors.grey.DEFAULT}
          >
            {t('staff.personal.space.pay.scale.Box.second.info.one')}
          </Typography>,
          <Typography
            key={'point-2.2'}
            variant="secondary-body"
            color={tailwindColors.grey.DEFAULT}
          >
            {t('staff.personal.space.pay.scale.Box.second.info.two')}
          </Typography>
        ]}
      />
      <ArrowPoints
        title={t('staff.personal.space.pay.scale.Box.third.info.title', { position })}
        points={[
          <div className="flex items-center gap-1" key={'point-3.1'}>
            <Typography variant="secondary-body">
              {t('staff.personal.space.pay.scale.Box.third.info.one')}
            </Typography>
            <ArrowDownIcon className="w-4 h-4 -rotate-90 " color={tailwindColors.grey.DEFAULT} />
            <Typography variant="secondary-body">
              {t('staff.personal.space.pay.scale.Box.third.info.one.two')}
            </Typography>
          </div>,
          <div className="flex items-center gap-1" key={'point-3.2'}>
            <Typography variant="secondary-body">
              {t('staff.personal.space.pay.scale.Box.third.info.two')}
            </Typography>
            <ArrowDownIcon className="w-4 h-4 -rotate-90 " color={tailwindColors.grey.DEFAULT} />
            <Typography variant="secondary-body">
              {t('staff.personal.space.pay.scale.Box.third.info.two.two')}
            </Typography>
          </div>,
          <Typography variant="tag" color={tailwindColors.secondary.DEFAULT} key={'point-3.3'}>
            {t('staff.personal.space.pay.scale.Box.third.info.three')}
          </Typography>
        ]}
        note={
          <Typography variant="secondary-body" color={tailwindColors.secondary.DEFAULT}>
            {t('staff.personal.space.pay.scale.Box.third.general.light')}
            <span className="font-semibold">
              {t('staff.personal.space.pay.scale.Box.third.general.bold')}
            </span>
          </Typography>
        }
      />
      <Typography variant="caption" color={tailwindColors.black.DEFAULT}>
        {t('staff.personal.space.pay.scale.Box.general.ending.one')}
      </Typography>
      <Typography variant="caption" color={tailwindColors.black.DEFAULT}>
        {t('staff.personal.space.pay.scale.Box.general.ending.two')}
      </Typography>
    </div>
  )
}

export default PayScaleInformation
